var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-browser-content" },
    [
      !_vm.menu
        ? _c("d-loading", { staticClass: "page loading" })
        : _c(
            "transition-group",
            {
              key: _vm.menu.name,
              staticClass: "page",
              attrs: { tag: "div", name: "fade-fast" },
            },
            [
              _vm.current
                ? _c(
                    "div",
                    {
                      key: _vm.current.id + "-current",
                      ref: "current",
                      staticClass: "current",
                    },
                    [
                      _c("div", {
                        ref: "currentHeader",
                        staticClass: "spacer",
                      }),
                      !_vm.isCurrentPage
                        ? [
                            _vm.current.header
                              ? _c("a", {
                                  staticClass: "header",
                                  attrs: { name: "current-menu-item" },
                                  domProps: {
                                    innerHTML: _vm._s(_vm.current.header.title),
                                  },
                                })
                              : _vm._e(),
                            _vm.current.content
                              ? _c("div", {
                                  staticClass: "content",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.current.content),
                                  },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._l(_vm.current.children, function (child, index) {
                        return _c(
                          "div",
                          { staticClass: "children" },
                          [
                            index > 0 ||
                            child.title !== _vm.current.header.title
                              ? _c("div", {
                                  staticClass: "title",
                                  domProps: { innerHTML: _vm._s(child.title) },
                                })
                              : _vm._e(),
                            _vm._l(child.children, function (item) {
                              return [
                                item.type === "attachment"
                                  ? _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "item media-item flat",
                                        class: {
                                          current: item === _vm.currentEpisode,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setEpisode(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "inner" }, [
                                          _c("img", {
                                            staticClass: "thumb",
                                            attrs: { src: item.thumbnail },
                                          }),
                                          _c("div", { staticClass: "body" }, [
                                            _c("div", {
                                              staticClass: "title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.title.rendered
                                                ),
                                              },
                                            }),
                                            _c("div", {
                                              staticClass: "content",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.caption.rendered
                                                ),
                                              },
                                            }),
                                          ]),
                                        ]),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      { key: item.id, staticClass: "item" },
                                      [
                                        _c("div", { staticClass: "inner" }, [
                                          _c("img", {
                                            staticClass: "thumb",
                                            attrs: { src: item.thumb },
                                          }),
                                          _c("div", {
                                            staticClass: "body",
                                            domProps: {
                                              innerHTML: _vm._s(item.title),
                                            },
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            }),
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.current
                ? _c("div", { key: "more", staticClass: "title more" }, [
                    _vm._v("More on the Site"),
                  ])
                : _vm._e(),
              _vm._l(_vm.menu, function (item) {
                return [
                  item !== _vm.current && item.type === "media"
                    ? _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "item media-item",
                          class: { flat: item.flat },
                        },
                        [
                          _c("div", { staticClass: "inner" }, [
                            _c("img", {
                              staticClass: "thumb",
                              attrs: { src: item.thumb },
                            }),
                            _c(
                              "div",
                              { staticClass: "body" },
                              [
                                _c("router-link", {
                                  staticClass: "title",
                                  attrs: { to: item.url },
                                  domProps: { innerHTML: _vm._s(item.title) },
                                }),
                                _c("div", {
                                  staticClass: "content",
                                  domProps: { innerHTML: _vm._s(item.caption) },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : item !== _vm.current
                    ? _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "item",
                          on: {
                            click: function ($event) {
                              return _vm.setCurrent(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "inner" }, [
                            _c("img", {
                              staticClass: "thumb",
                              attrs: { src: item.thumb },
                            }),
                            _c("div", {
                              staticClass: "body",
                              domProps: { innerHTML: _vm._s(item.title) },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }